import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IWorkOrderStatsResponse } from "../models/WorkOrder";

export default function useWorkOrderStats() {
  const { get } = useApiHelper();

  const workOrderStats = useQuery({
    queryKey: ["workOrderStats"],
    queryFn: () => get<IWorkOrderStatsResponse>("/workorder/stats"),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return workOrderStats;
}